import { blockTheme } from '../block-theme/blockTheme'

export interface LessonProgressBarProps {
  /** Total number of segments (default: 5) */
  total?: number
  /** Current active segment (0-indexed, default: 1) */
  current?: number
  /** Fill colour (CSS). Default — lavender `blockTheme.quiz.primary`, as the
   *  lesson progress in mobile and web (`blockPalette.primary`, #b389f2). */
  accent?: string
}

function LessonProgressBar({
  total = 5,
  current = 1,
  accent = blockTheme.quiz.primary,
}: LessonProgressBarProps) {
  // Single solid rounded bar (ref `bar-rounded` — MobilePreviewFrame.tsx:1325-1341):
  // a filled track proportional to progress with a Duolingo-style gloss inside.
  const progress = total > 0 ? (Math.min(current + 1, total) / total) * 100 : 0
  return (
    <div
      data-progress-track
      className="mx-auto h-3 w-[95%] overflow-hidden rounded-full"
      // Track — muted grey, like mobile `blockPalette.muted`
      style={{ backgroundColor: blockTheme.quiz.muted }}
    >
      <div
        data-progress-fill
        className="relative h-full overflow-hidden rounded-full transition-[width] duration-700 ease-in-out"
        style={{ width: `${progress}%`, backgroundColor: accent }}
      >
        {/* white by design: glossy highlight over the accent-coloured fill, not app surface */}
        <div className="pointer-events-none absolute left-1.5 right-1.5 top-[20%] h-[30%] rounded-full bg-white/25" />
      </div>
    </div>
  )
}

export { LessonProgressBar }
